import React from 'react';
import Card from '../components/Card';
import landing from '../assets/landing.png';
import orion from '../assets/orion.png';
import s3rcel from '../assets/s3rcel.png';
import thedaotool from '../assets/thedaotool.png';
import disposable from '../assets/disposable.png';
import pantsir from '../assets/pantsir-banner.png';
import codelens from '../assets/codelens.png';

const pages = [
  {
    title: 'Pantsir',
    description:
      'A platform for developers and security teams to build practical secure-coding skills.',
    image: pantsir,
    link: 'https://www.pantsir.cc',
    code: 'https://github.com/Pantsir-Labs',
  },
  {
    title: 'The DAO Tool',
    description: 'A modern open-source platform to manage bounties, payments, and DAO workflows.',
    image: thedaotool,
    link: 'https://www.thedaotool.com',
    code: 'https://github.com/kartikmehta8/thedaotool',
  },
  {
    title: 'Code Lens',
    description:
      'Get instant, intelligent feedback on every pull request. Coderabbit alternative, frontend only.',
    image: codelens,
    link: 'https://codelens-olive.vercel.app',
    code: 'https://github.com/kartikmehta8/codelens',
  },
  {
    title: 'S3rcel - Blazing Fast PR Previews',
    description:
      'Vercel-like deployment system using GitHub Actions, AWS S3, and CloudFront enabling PR preview.',
    image: s3rcel,
    link: 'https://writer.mrmehta.in/s3rcel-deploying-pr-previews-for-react-using-aws-s3-and-cloudfront',
    code: 'https://github.com/kartikmehta8/s3rcel-pr-preview',
  },
  {
    title: 'Disposable Chat - Private Peer-to-Peer Messaging',
    description:
      'A private, disposable chat. Communicate securely in real-time without storing messages.',
    image: disposable,
    link: 'https://chat.mrmehta.in',
    code: '',
  },
  {
    title: 'The Orion Framework [Proof of Concept]',
    description: 'Express on Steroids: The Ultimate Plug-and-Play Backend Architecture.',
    image: orion,
    link: 'https://orion.mrmehta.in',
    code: '',
  },
];

const Experiments = () => {
  return (
    <div className="flex justify-center">
      <div className="poppins container p-4 text-gray-900 min-h-screen animate-fadeIn">
        <div className="flex flex-col items-center mt-16">
          <img
            src={landing}
            alt="Landing Banner"
            className="w-full max-w-4xl g mb-8"
            loading="lazy"
          />
          <h1 className="text-2xl underline font-bold mb-4">Experiments</h1>
          <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            {pages.map((page, index) => (
              <Card
                key={index}
                title={page.title}
                description={page.description}
                image={page.image}
                link={page.link}
                code={page.code}
                aria-label={`${page.title} - ${page.description}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experiments;
